/* Imports */
import React, { useState } from "react"
import { Form, Input } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"
import DemoItem from "../../components/DemoItem"

import commonProps from "../../data/common-props"

const FormPage = () => {
    const [inputs, setInputs] = useState({
        name: "",
        email: "",
        password: "",
    })

    const handleInputs = e =>
        setInputs({
            ...inputs,
            [e.target.id]: e.target.value,
        })

    const resetForm = () =>
        setInputs({
            name: "",
            email: "",
            password: "",
        })

    const item = {
        content: (
            <Form
                buttonPrimary="Send"
                buttonSecondary="reset"
                buttonSecondaryText="Cancel"
                onClickSecondary={resetForm}
            >
                <Input label="Name" id="name" onChange={handleInputs} value={inputs.name} />
                <Input label="Email" id="email" type="email" onChange={handleInputs} value={inputs.email} />
                <Input label="Password" id="password" password onChange={handleInputs} value={inputs.password} />
            </Form>
        ),
        code: 'const [inputs, setInputs] = useState({\n        name: "",\n    email: "",\n    password: "",\n})\n\nconst handleInputs = e =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\nconst resetForm = () =>\n    setInputs({\n        name: "",\n        email: "",\n        password: "",\n    })\n\n<Form\n    buttonPrimary="Send"\n    buttonSecondary="reset"\n    buttonSecondaryText="Cancel"\n    onClickSecondary={resetForm}\n>\n    <Input label="Name" id="name" onChange={handleInputs} value={inputs.name} />\n    <Input label="Email" id="email" type="email" onChange={handleInputs} value={inputs.email} />\n    <Input label="Password" id="password" password onChange={handleInputs} value={inputs.password} />\n</Form>',
    }

    const propsItems = [
        {
            name: "buttonPrimary",
            type: "String",
            example: "Create account",
        },
        {
            name: "buttonSecondary",
            type: "String",
            example: "cancel",
            possible: '"cancel" | "reset"',
        },
        {
            name: "buttonSecondaryText",
            type: "String",
            example: "Reset form",
            possible: "",
            default: (
                <>
                    If buttonSecondary is equal to <code>cancel</code>: "Cancel", else if buttonSecondary is equal to{" "}
                    <code>reset</code>: "Reset", or none
                </>
            ),
        },
        {
            name: "buttonSecondaryTo",
            type: "String",
            example: "/my-account",
        },
        {
            name: "onClickSecondary",
            type: "Function",
        },
        {
            name: "iconLeftPrimary",
            type: "String",
            example: "send-solid",
            possible: commonProps.fajnyIcons,
        },
        {
            name: "iconRightPrimary",
            type: "String",
            example: "chevron-right-solid",
            possible: commonProps.fajnyIcons,
        },
        {
            name: "iconLeftSecondary",
            type: "String",
            example: "chevron-left-solid",
            possible: commonProps.fajnyIcons,
        },
        {
            name: "iconRightSecondary",
            type: "String",
            example: "close-solid",
            possible: commonProps.fajnyIcons,
        },
    ]

    return (
        <ComponentPage propsItems={propsItems}>
            <DemoItem demo={item} />
        </ComponentPage>
    )
}

export default FormPage
